import { IkeToken } from '@ikegps/core-api';
import { ImageButton } from '../../components/button/image.button';
import { MaterialIcon } from '../../components/icon/icons';
import { addStyles } from '../../components/theme';
import { T } from '../../i18n/index';
import type { MithrilVNode } from '../../mithril';
import { IkePageName } from '../../page/page';
import { Services } from '../../services';
import type { RouteParams } from '../../services/route.service';
import { CSS, Style } from './photomeasure.button.style';

addStyles(Style);

function stopPropagation(e: Event) {
	e.stopPropagation();
}

export const PhotomeasureButton = {
	view(tagId: string, collectionUUID?: string): MithrilVNode {
		'';
		return ImageButton.view(MaterialIcon.PHOTO_MEASURE, {
			title: T.LINK_PHOTOMEASURE,
			className: CSS.container,
			href: IkePageName.collectionMeasure,
			hrefParams: {
				d: Services.Department.current.objectId,
				t: tagId,
				collection: collectionUUID,
			},
			disabled: false,
			onclick: stopPropagation,
		});
	},

	getParams(tagId: string, collectionUUID?: string): RouteParams {
		return {
			d: Services.Department.current.objectId,
			t: tagId,
			collection: collectionUUID,
		};
	},

	getUrl(tagId: string, collectionId?: string, collectionUUID?: string): string {
		if (Services.Token.has(IkeToken.FEATURE_MAP_EDIT)) {
			const departmentId = Services.Department.current.objectId;
			return collectionUUID != null
				? `measure?d=${departmentId}&t=${tagId}&collection=${collectionUUID}`
				: `measure?d=${departmentId}&t=${tagId}`;
		}

		return collectionId != null ? `m/${tagId}/${collectionId}` : `m/${tagId}`;
	},
};
